export const TypeList = [
    { text: 'string', value: 'text', shape: null, variant: null },   //text
    { text: 'textarea', value: 'textarea', shape: null, variant: null }, //textarea
    { text: 'checkboxlist', value: 'checklist', shape: null, variant: null },  //checklist
    { text: 'checkbox', value: 'checkbox', shape: null, variant: null },  //checkbox
    { text: 'date', value: 'date', shape: null, variant: null }, //date
    { text: 'dateWithMaxToday', value: 'dateWithMaxToday', shape: null, variant: null }, //date
    { text: 'dropdownlist', value: 'select', shape: null, variant: null },  //select
    { text: 'usstates', value: 'states', shape: null, variant: null },  //states
    { text: 'radiogroup', value: 'radio', shape: null, variant: "inline" },  //radio
    { text: 'radiogroup-vertical', value: 'radio', shape: "vertical", variant: null },  //radio
    { text: 'radiogrouplist', value: 'radiogrouplist', shape: null, variant: null },  //radiogrouplist
    { text: 'integer', value: 'integer', shape: null, variant: null },  //integer
    { text: 'yes|no', value: 'radio', shape: null, variant: "inline" },  //integer
    { text: 'ssn', value: 'ssn', shape: null, variant: null },  //ssn
    { text: 'zip', value: 'zip', shape: null, variant: null },  //zip
    { text: 'usphone', value: 'phone', shape: null, variant: null },  //phone
    { text: 'email', value: 'email', shape: null, variant: null },  //email
    { text: 'markdown', value: 'markdown', shape: "vertical", variant: null }, //markdown
    { text: 'currency', value: 'currency', shape: null, variant: null },  //currency
    { text: 'checkbox-attestation', value: 'attest', shape: "attest", variant: null }, //attest
    { text: 'signature', value: 'signature', shape: null, variant: null },  //signature
    { text: 'number', value: 'number', shape: null, variant: null },  //number
    { text: 'html', value: 'html', shape: "vertical", variant: null },

    { text: 'integer-text', value: 'integer-text', shape: null, variant: null },
    { text: 'genentechHubPharmacy', value: 'genentechHubPharmacy', shape: null, variant: null },
    { text: 'string-gooddays-Treatment', value: 'string-gooddays-Treatment', shape: null, variant: null },
    { text: 'dropdownlist-gooddays-Treatment', value: 'dropdownlist-gooddays-Treatment', shape: null, variant: null },
    { text: 'healthwellmedications', value: 'healthwellmedications', shape: null, variant: null },
    { text: 'healthwellfundselector', value: 'healthwellfundselector', shape: null, variant: null },
    { text: 'sanofidiagnosiscodes', value: 'sanofidiagnosiscodes', shape: null, variant: null },
    { text: 'sanofifacilities', value: 'sanofifacilities', shape: null, variant: null },
    { text: 'amgendrugchecklist', value: 'amgendrugchecklist', shape: null, variant: null },
    { text: 'taxid', value: 'taxid', shape: null, variant: null },

]

export const ListEditorTypes = [
    "dropdownlist",
    "radiogrouplist",
    "radiogroup",
    "radiogroup-vertical",
    "checkboxlist"
]


export const KeyListPretty = [
    "Patient", "Insurance", "Income & Eligibility", "Medical", "Provider", "Order / Logistics", "Other", "Attestation & Signature"
];

export const KeyList = [
    "patient", "insurance", "income & eligibility", "medical", "provider", "order / logistics", "other", "attestation & signature"
];

export const OperatorNames = {
    "equal": "EqualTo",
    "notEqual": "NotEqualTo",
    "contains": "Contains",
    "doesNotContain": "NotContains"
};

export const FieldTypes = [
    {
        FieldType: "string",
        Id: 100
    },

    {
        FieldType: "integer",
        Id: 101
    },

    {
        FieldType: "currency",
        Id: 102
    },

    {
        FieldType: "date",
        Id: 103
    },

    {
        FieldType: "datetime",
        Id: 104
    },

    {
        FieldType: "time",
        Id: 105
    },

    {
        FieldType: "usphone",
        Id: 106
    },

    {
        FieldType: "email",
        Id: 107
    },

    {
        FieldType: "ssn",
        Id: 108
    },

    {
        FieldType: "textarea",
        Id: 109
    },

    {
        FieldType: "yes|no",
        Id: 110
    },

    {
        FieldType: "radiogroup",
        Id: 111
    },

    {
        FieldType: "usstates",
        Id: 112
    },

    {
        FieldType: "checkboxlist",
        Id: 113
    },

    {
        FieldType: "dropdownlist",
        Id: 114
    },

    {
        FieldType: "checkbox",
        Id: 115
    },

    {
        FieldType: "zip",
        Id: 116
    },

    {
        FieldType: "markdown",
        Id: 117
    },

    {
        FieldType: "checkbox-attestation",
        Id: 118
    },

    {
        FieldType: "signature",
        Id: 120
    },

    {
        FieldType: "radiogroup-vertical",
        Id: 121
    },

    {
        FieldType: "currency-dollars",
        Id: 125
    },

    {
        FieldType: "url",
        Id: 127
    },

    {
        FieldType: "checkboxlist-amgen",
        Id: 130
    },

    {
        FieldType: "radiogrouplist",
        Id: 131
    },

    {
        FieldType: "number",
        Id: 200
    },

    {
        FieldType: "html",
        Id: 300
    },

    {
        FieldType: "integer-text",
        Id: 400
    },

    {
        FieldType: "genentechHubPharmacy",
        Id: 18000
    },

    {
        FieldType: "string-gooddays-Treatment",
        Id: 20000
    },

    {
        FieldType: "dropdownlist-gooddays-Treatment",
        Id: 20001
    },

    {
        FieldType: "dateWithMaxToday",
        Id: 20002
    },

    {
        FieldType: "healthwellmedications",
        Id: 113
    },

    {
        FieldType: "healthwellfundselector",
        Id: 114
    },

    {
        FieldType: "sanofidiagnosiscodes",
        Id: 114
    },

    {
        FieldType: "sanofifacilities",
        Id: 114
    },
    {
        FieldType: "amgendrugchecklist",
        Id: 130
    },
    {
        FieldType: "taxid",
        Id: 100
    }
]
    ;

export const CommonListNames = [
    {
        "Id": 100,
        "Name": "gender"
    },
    {
        "Id": 101,
        "Name": "insurancetypes"
    },
    {
        "Id": 102,
        "Name": "besttimetocall"
    },
    {
        "Id": 103,
        "Name": "genderConcise"
    },
    {
        "Id": 104,
        "Name": "defaultsUnitOfMeasure"
    }
];

export const DataKey = [
    "BrandName",
    "Ndc11",
    "Ndc10",
    "Patient Name Prefix",
    "Patient Name First",
    "Patient Name Middle",
    "Patient Name Last",
    "Patient Name Suffix",
    "Patient Name Initials",
    "Patient Name Middle Initial",
    "Patient DOB",
    "Patient SSN",
    "EncryptedSSN",
    "Patient Primary Language",
    "Patient Address 1",
    "Patient Address 2",
    "Patient City",
    "Patient State",
    "Patient Zip Code",
    "Patient Phone Home",
    "Patient Phone Cell",
    "Patient Phone Work",
    "Patient Email Address",
    "Patient Gender",
    "Patient Gender Concise",
    "Provider Facility NPI",
    "Provider Facility Name",
    "FacilityPhysicalAddress1",
    "Provider Facility Address 1",
    "FacilityPhysicalAddress2",
    "Provider Facility Address 2",
    "FacilityPhysicalCity",
    "Provider Facility City",
    "FacilityPhysicalState",
    "Provider Facility State",
    "FacilityPhysicalZip",
    "Provider Facility Zip Code",
    "Provider Facility Phone",
    "Provider Facility Fax",
    "Provider Facility Tax ID",
    "Provider Facility CLIA",
    "Medical Patient Diagnosis Codes",
    "Medical MorphoSys Patient Diagnosis Codes",
    "Provider Physician NPI Number",
    "Provider Physician Name Prefix",
    "Provider Physician Name First",
    "Provider Physician Name Middle",
    "Provider Physician Name Last",
    "Provider Physician Name Suffix",
    "Provider Physician Name Initials",
    "Provider Physician Address 1",
    "Provider Physician Address 2",
    "Provider Physician City",
    "Provider Physician State",
    "Provider Physician Zip",
    "Provider Physician Phone",
    "Provider Physician Fax",
    "Provider Physician Tax ID",
    "Provider Physician Group Tax ID",
    "Provider Physician State License",
    "Provider Physician DEA",
    "Provider Physician Role At Practice",
    "Insurance Does Patient Have Pharmacy Insurance",
    "Insurance Pharmacy Insurance Name",
    "Insurance Pharmacy Insurance Subscriber Name",
    "Insurance Pharmacy Insurance Phone",
    "Insurance Pharmacy Insurance Policy Holder Name",
    "Insurance Pharmacy Insurance ID Policy Number",
    "Insurance Pharmacy Insurance Group Number",
    "Insurance Pharmacy Insurance Group Name",
    "Insurance Pharmacy Insurance BIN Number",
    "Insurance Pharmacy Insurance PCN Number",
    "Income Gross Yearly Household Income",
    "Income MorphoSys Gross Yearly Household Income",
    "Income Gross Monthly Household Income",
    "Income Number of Adults in Household",
    "Income Number Of Children In Household",
    "Income Number of People in Household",
    "Patient Best Time to Call",
    "PharmacyBenefitInsurancePBMPaidToDate",
    "PharmacyBenefitInsurancePBMCoInsurancePercent",
    "PharmacyBenefitInsuranceLastUpdated",
    "Insurance Does Patient Have Insurance",
    "Insurance Does Patient Have Medical Insurance",
    "Insurance Does Patient Have Primary Medical Insurance",
    "Insurance Primary Medical Insurance Name",
    "Insurance Primary Medical Insurance Phone",
    "Insurance Primary Phone Number",
    "Insurance Primary Medical Insurance ID Policy Number",
    "Insurance Primary Medical Insurance Group Number",
    "Insurance Primary Medical Insurance Policy Holder Name",
    "Insurance Primary Subscriber First Name",
    "Insurance Primary Subscriber Last Name",
    "Insurance Primary Medical Insurance Policy Holder DOB",
    "Insurance Primary Policy Holder Date of Birth",
    "Insurance Primary Medical Insurance Policy Holder Relationship",
    "Insurance Primary Policy Holder Relationship to Patient",
    "Insurance Primary Medical Relationship to Policy Holder",
    "Insurance Primary Medical Insurance Effective Date",
    "Insurance Primary Medical Effective Date",
    "Insurance Does Patient Have Secondary Medical Insurance",
    "Insurance Secondary Medical Insurance Name",
    "Insurance Secondary Medical Insurance Phone",
    "Insurance Secondary Phone Number",
    "Insurance Secondary Medical Insurance ID Policy Number",
    "Insurance Secondary Medical Insurance Group Number",
    "Insurance Secondary Medical Insurance Policy Holder Name",
    "Insurance Secondary Subscriber First Name",
    "Insurance Secondary Subscriber Last Name",
    "Insurance Secondary Medical Insurance Policy Holder DOB",
    "Insurance Secondary Subscriber Date of Birth",
    "Insurance Secondary Medical Insurance Policy Holder Relationship",
    "Insurance Secondary Medical Relationship to Policy Holder",
    "Insurance Secondary Insurance Policy Holder Relationship",
    "Insurance Secondary Policy Holder Relationship to Patient",
    "TertiaryInsuranceCarrierName",
    "TertiaryInsuranceCarrierPhone",
    "TertiaryInsurancePolicyNumber",
    "TertiaryInsuranceGroupNumber",
    "TertiaryInsuranceSubscriberName",
    "Insurance Tertiary Subscriber First Name",
    "Insurance Tertiary Subscriber Last Name",
    "Insurance Tertiary Medical Insurance Policy Holder DOB",
    "Insurance Tertiary Medical Insurance Policy Holder Relationship",
    "Insurance Tertiary Medical Relationship to Policy Holder",
    "Insurance Patient Insurance Types",
    "Medical Sanofi Patient Diagnosis Codes",
    "Medical BeiGene Patient Diagnosis Codes",
    "Provider Primary Contact First Name",
    "Provider Primary Contact Last Name",
    "Provider Primary Contact Email Address",
    "Provider Primary Contact Phone",
    "Provider Primary Contact Fax Number",
    "Provider Primary Contact Fax",
    "Other AMGEN Drug Selection",
    "Insurance Coherus BV Preference",
    "Formulary Drug Step 1",
    "Insurance Primary Insured Same As Patient",
    "Insurance Secondary Insured Same As Patient",
    "Insurance Tertiary Insured Same As Patient"
];

export const FileExtensions = {
    json: {
        "name": "JSON files",
        "extensions": ["json"]
    },
    formClass: {
        "name": "Class files",
        "extensions": ["cs"]
    },
    sql: {
        "name": "SQL files",
        "extensions": ["sql"]
    },
}

export const SpecialCharacters = [
    "~",
    "`",
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "-",
    "+",
    "=",
    "{",
    "}",
    "[",
    "]",
    "|",
    "\\",
    "/",
    ":",
    ";",
    "\"",
    "'",
    "<",
    ">",
    ",",
    ".",
    "?"
];

export const standardQuestionTabs = [
    { value: 'patient', label: 'Patient' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'income & eligibility', label: 'Income & Eligibility' },
    { value: 'medical', label: 'Medical' },
    { value: 'provider', label: 'Provider' },
    { value: 'order / logistics', label: 'Order & Logistics' },
    { value: 'other', label: 'Other' },
    { value: 'attestation & signature', label: 'Attestation & Signature' }
]

export const standardQuestionPatientCategories = [
    { value: 'personal information', label: 'Personal Information' },
    { value: 'contact information', label: 'Contact Information' },
    { value: 'caregiver information', label: 'Caregiver Information' }
]

export const standardQuestionInsuranceCategories = [
    { value: 'primary medical insurance', label: 'Primary Medical Insurance' },
    { value: 'secondary medical insurance', label: 'Secondary Medical Insurance' },
    { value: 'prescription insurance', label: 'Prescription Insurance' }
]

export const standardQuestionIncomeCategories = [
    { value: 'income information', label: 'Income Information' },
    { value: 'household information', label: 'Household Information' }
]

export const standardQuestionMedicalCategories = [
    { value: 'diagnosis', label: 'Diagnosis' }
]

export const standardQuestionProviderCategories = [
    { value: 'prescriber information', label: 'Prescriber Information' },
    { value: 'facility information', label: 'Facility Information' },
    { value: 'primary contact information', label: 'Primary Contact Information' }
]

export const standardQuestionAttestationCategories = [
    { value: 'patient consent', label: 'Patient Consent' }
]